<template lang="pug">
    .component-vehicle-overview
        transaction(:item="transaction", :type="'detail'")
</template>
<script type="text/babel">
    import KeplerBackofficeSdk from "src/lib/kepler/backoffice";
    import Vehicle from 'components/backoffice/Vehicle.vue'
    import VehicleHardware from "components/backoffice/VehicleHardware";
    import Transaction from "../Transaction";

    export default{
        name: "TabbedTransaction",
        components: {
            Transaction,
            VehicleHardware,
            Vehicle
        },
        data(){
            return {
                transaction: null
            }
        },
        created() {
            KeplerBackofficeSdk.transactions.select(this.$route.params.id).get((data)=>{
                this.transaction = data
            })
        }
    }
</script>
<style lang="sass" rel="stylesheet/sass">
    .driver-profile
        margin: 10px
</style>


// WEBPACK FOOTER //
// Transaction.vue?754765a0